const triggerGetTransactionDetails = (sessionId, clientIp, accountNbr, host) => {
    const reqPayload = {
        security: {
            session: {
                id: sessionId
            },
            client_ip: clientIp,
            version: "2",
        },
        type: "c",
        pageNumber: 1,
        pageSize: 10,
        id: accountNbr,
        groupBy: "",
        order: ""
    };
    const requestOptions = {
        method: "POST",
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        body: JSON.stringify(reqPayload)
    };
    return fetchApiWu(`https://${host}/wudgtsrvs/mobiliser/rest/channel/GwpGetTransactionDetails?timestamp=${new Date().getTime()}`, requestOptions, "GwpGetTransactionDetails")
};